import { Pipe, PipeTransform } from '@angular/core';
import {
  GridRegistrationTypeConst,
  GridRegistrationTypeEnum,
  PhasesTypeEnum
} from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';
import { GridRegistrationRequestService } from '@bo-client/activation-management/grid-registration/grid-registration-request.service';
import { ErrorStepsEnum } from '@bo-client/activation-management/shared/forms/create-forms-errors-model';

@Pipe({
  name: 'gridRegistrationTypePipe'
})
export class GridRegistrationTypePipe implements PipeTransform {
  transform(value: GridRegistrationTypeEnum) {
    const idx = GridRegistrationTypeConst.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = GridRegistrationTypeConst[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'gridRegistrationErrorStepsPipe'
})
export class GridRegistrationErrorStepsPipe implements PipeTransform {
  transform(listErrors: ShowErrorModel[], stepName: ErrorStepsEnum) {
    for (let i = 0; i < listErrors.length; i++) {
      if (listErrors[i].step == stepName) {
        return true;
      }
    }
    return false;
  }
}

@Pipe({
  name: 'gridRegistrationErrorListStepsPipe'
})
export class GridRegistrationListErrorStepsPipe implements PipeTransform {
  transform(listErrors: ShowErrorModel[], stepName: ErrorStepsEnum) {
    return listErrors.filter((x) => x.step == stepName);
  }
}

@Pipe({
  name: 'gridRegistrationConnectedPhasenPipe'
})
export class GridRegistrationConnectedPhasenPipe implements PipeTransform {
  constructor(public gridRegistrationService: GridRegistrationRequestService) {}

  transform(listConnectedPhasen, value: PhasesTypeEnum) {
    if (value) {
      const idx = this.gridRegistrationService.phasesType.findIndex((x) => x.value == value);
      if (idx != -1) {
        const phasesNumber = +this.gridRegistrationService.numberOfPhasesType[idx].displayName;
        return listConnectedPhasen.filter((ele) => ele.displayName.match(/L/g).length == phasesNumber);
      }
    }
    return listConnectedPhasen;
  }
}
